var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPlusBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#3C5BD2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0003 6.85718C13.0003 6.30489 12.5526 5.85718 12.0003 5.85718C11.448 5.85718 11.0003 6.30489 11.0003 6.85718V11H6.85742C6.30514 11 5.85742 11.4478 5.85742 12C5.85742 12.5523 6.30514 13 6.85742 13H11.0003V17.1429C11.0003 17.6952 11.448 18.1429 12.0003 18.1429C12.5526 18.1429 13.0003 17.6952 13.0003 17.1429V13H17.1431C17.6954 13 18.1431 12.5523 18.1431 12C18.1431 11.4478 17.6954 11 17.1431 11H13.0003V6.85718Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlusBlue);
export default __webpack_public_path__ + "static/media/ic_plus_blue.6b56338d32a81dd8c94bb27d6e2fdcca.svg";
export { ForwardRef as ReactComponent };